import { render, staticRenderFns } from "./ShopType.vue?vue&type=template&id=3081ba58&scoped=true&"
import script from "./ShopType.vue?vue&type=script&lang=js&"
export * from "./ShopType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3081ba58",
  null
  
)

export default component.exports